// AUTO-GENERATED by scripts/core/sync-error-labels.mjs — DO NOT EDIT BY HAND.
// Frozen snapshot of TYPO3 globalLabels per locale, used by the error/404
// boundaries so they render localized text even when the backend is down.
// Refresh: npm run labels:sync (from packages/corekit).

export type ErrorLabelLocale = 'de' | 'en';

export const errorLabels: Record<ErrorLabelLocale, Record<string, string>> =
{
  "de": {
    "breadcrumbs": "Breadcrumb Navigation",
    "close": "Schließen",
    "navigateTo": "Gehe zu",
    "apiErrorTagline": "Fehler beim Laden der Seite",
    "apiErrorTitle": "API-Ladefehler",
    "apiErrorDescription": "Diese Seite konnte nicht aus dem CMS geladen werden. Sie ist möglicherweise vorübergehend nicht verfügbar oder du hast keine Berechtigung, auf diesen Inhalt zuzugreifen.",
    "appErrorTagline": "Anwendungsfehler",
    "appErrorTitle": "Etwas ist schiefgelaufen",
    "appErrorDescription": "Beim Laden dieser Seite ist ein unerwarteter Fehler aufgetreten. Bitte versuche es erneut oder kehre zur Startseite zurück.",
    "404Tagline": "Seite nicht gefunden",
    "404Title": "404",
    "404Description": "„Die Seite, die du suchst, existiert nicht oder wurde verschoben. Bitte überprüfe die URL oder gehe zurück zur Startseite.",
    "criticalErrorTagline": "Kritischer Fehler",
    "criticalErrorTitle": "Systemfehler",
    "criticalErrorDescription": "Ein schwerwiegender Fehler hat verhindert, dass die Anwendung korrekt geladen werden konnte. Vermutlich liegt ein systemweiter Ausfall vor.",
    "resetButtonLabel": "Erneut versuchen",
    "homeButtonLabel": "Zur Startseite",
    "loading": "Laden...",
    "overview": "Übersicht",
    "dateTimeFrom": "ab",
    "dateTimeOClock": "Uhr",
    "dateTime": "Datum & Uhrzeit",
    "location": "Location",
    "title": "Titel",
    "downloadSuccess": "Download erfolgreich",
    "downloadError": "Download fehlgeschlagen",
    "toRegistration": "Zur Anmeldung",
    "toEvent": "Zum Event",
    "noEvents": "Derzeit keine Events verfügbar",
    "paginationPrevious": "Zurück",
    "paginationNext": "Weiter",
    "allLocations": "Alle Standorte",
    "allCategories": "Alle Kategorien",
    "eventCategory": "Art der Veranstaltung",
    "eventLanguage": "Sprache",
    "loadMore": "Mehr anzeigen",
    "fabOpen": "Kontakt öffnen",
    "fabClose": "Kontakt schließen"
  },
  "en": {
    "breadcrumbs": "Breadcrumb Navigation",
    "close": "Close",
    "navigateTo": "Navigate to",
    "apiErrorTagline": "Error Loading Page",
    "apiErrorTitle": "API loading Error",
    "apiErrorDescription": "This page couldn't be loaded from the CMS. It might be temporarily unavailable or you don't have access to this content.",
    "appErrorTagline": "Application Error",
    "appErrorTitle": "Something went wrong",
    "appErrorDescription": "An unexpected error occurred while loading this page. Please try again or navigate back to the homepage.",
    "404Tagline": "Page Not Found",
    "404Title": "404",
    "404Description": "The page you're looking for doesn't exist or has been moved. Please check the URL or navigate back home.",
    "criticalErrorTagline": "Critical Error",
    "criticalErrorTitle": "System Failure",
    "criticalErrorDescription": "A critical error occurred that prevented the application from loading properly. This is likely due to a system-level failure.",
    "resetButtonLabel": "Try again",
    "homeButtonLabel": "Go to homepage",
    "loading": "Loading...",
    "overview": "Overview",
    "dateTimeFrom": "from",
    "dateTimeOClock": "h",
    "dateTime": "Date & Time",
    "location": "Location",
    "title": "Title",
    "downloadSuccess": "Download successful",
    "downloadError": "Download failed",
    "toRegistration": "To registration",
    "toEvent": "To event",
    "noEvents": "No events found",
    "paginationPrevious": "Previous",
    "paginationNext": "Next",
    "allLocations": "All Locations",
    "allCategories": "All Categories",
    "eventCategory": "Type of event",
    "eventLanguage": "Language",
    "loadMore": "Load more",
    "fabOpen": "Open contact",
    "fabClose": "Close contact"
  }
};
